function StarSmIcon() {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.76411 0.726615L5.50598 2.22981L7.16485 2.47086C7.86472 2.57255 8.14417 3.43262 7.63774 3.92626L6.43737 5.09634L6.72074 6.74851C6.84029 7.44554 6.10867 7.97709 5.4827 7.648L3.99896 6.86795L2.51522 7.648C1.88924 7.97709 1.15762 7.44554 1.27717 6.74851L1.56054 5.09634L0.360171 3.92626C-0.146256 3.43262 0.133197 2.57255 0.833061 2.47086L2.49193 2.22981L3.2338 0.726615C3.54679 0.0924304 4.45112 0.0924304 4.76411 0.726615Z"
        fill="#FFF4DE"
      />
    </svg>
  );
}

export default StarSmIcon;
